import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import { Fragment, JSX } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { setCancelationModalOpen } from 'v3/data/store/cancellationNavigation/actions';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';
import { CancellationErrorNotification } from 'v3/pages/OnlineContracting/Cancellation/Error';
import { RefundConflictError } from 'v3/pages/OnlineContracting/Cancellation/Error/RefundConflictError';
import { OrderCanceledSuccessfullyStep } from 'v3/pages/OnlineContracting/Cancellation/Steps/OrderCanceledSuccessfullyStep';
import { ReasonCancellationStep } from 'v3/pages/OnlineContracting/Cancellation/Steps/ReasonCancellationStep';
import { RefusedCancellationStep } from 'v3/pages/OnlineContracting/Cancellation/Steps/RefusedCancellationStep';
import { RequestAcceptedStep } from 'v3/pages/OnlineContracting/Cancellation/Steps/RequestAcceptedStep';
import { RequestCancellationStep } from 'v3/pages/OnlineContracting/Cancellation/Steps/RequestCancellationStep';
import { RequestRefundStep } from 'v3/pages/OnlineContracting/Cancellation/Steps/RequestRefundStep';
import {
  confirmationDialogPaperPropsStyle,
  StyledDialogContent,
  StyledIconButton,
} from 'v3/shared/components/Modal/SellerCodeModal/styles';

export const CancellationFlowModal = () => {
  const { currentCancelationState, isCancellationDialogOpen } = useStoreSelector(
    (state) => state.cancellationNavigation,
  );

  const stepsComponents: Record<CancellationNavigationEnum, () => JSX.Element> = {
    [CancellationNavigationEnum.CANCELLATION_NOT_STARTED]: RequestCancellationStep,
    [CancellationNavigationEnum.CANCELLATION_STARTED]: RequestAcceptedStep,
    [CancellationNavigationEnum.REFUND_STARTED]: RequestRefundStep,
    [CancellationNavigationEnum.CANCELLATION_ACCEPTED]: ReasonCancellationStep,
    [CancellationNavigationEnum.PROCESSING_CANCELLATION]: OrderCanceledSuccessfullyStep,
    [CancellationNavigationEnum.CANCELLATION_REFUSED]: RefusedCancellationStep,
    [CancellationNavigationEnum.CANCELLATION_FINISHED]: RequestCancellationStep,
  };

  const renderContent = () => {
    const StepComponent = currentCancelationState ? stepsComponents[currentCancelationState] : null;
    return StepComponent ? <StepComponent /> : null;
  };

  const handleModalOpen = (state: boolean) => {
    setCancelationModalOpen(state);
  };

  return (
    <Fragment>
      <CancellationErrorNotification />
      <RefundConflictError />
      <Dialog
        open={isCancellationDialogOpen}
        onClose={() => handleModalOpen(false)}
        PaperProps={{
          sx: confirmationDialogPaperPropsStyle,
        }}
      >
        <StyledIconButton onClick={() => handleModalOpen(false)}>
          <CloseIcon />
        </StyledIconButton>
        <StyledDialogContent>{renderContent()}</StyledDialogContent>
      </Dialog>
    </Fragment>
  );
};
